module.exports = __webpack_public_path__ + "media/luxury-2026/lake-top-down-0fdf4a8b.jpg";